import { initGraphQLTada } from '@repo/graphql/gql.tada';

import { introspection } from './graphql-env';

export const graphql = initGraphQLTada<{
  introspection: introspection;
  scalars: {
    Time: string;
    Date: string;
    DateTime: string;
    Uri: string;
  };
}>();

export type { FragmentOf, ResultOf, VariablesOf } from '@repo/graphql/gql.tada';
export { maskFragments, readFragment } from '@repo/graphql/gql.tada';
